import React from "react";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";

const tableSizes = [10, 25, 50, 100];

export default function ChangeTableSize({ defaultTableSize, name, title,  testId }) {
  const { t } = useTranslation();
  const methods = useFormContext();

  if (!defaultTableSize) {
    defaultTableSize = 10;
  }

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <FormControl fullWidth>
          <InputLabel id="table-size-select-label">{t(title)}</InputLabel>
          <Select
            labelId="table-size-select-label"
            id="table-size-select"
            label={t(title)}
            data-testid={testId}
            {...field}
          >
            {tableSizes.map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}
